<template>
  <div class="feedback-scale" dir="ltr">
    <v-slider
      class="feedback-slider"
      :value="value" :aria-label="label" min="0" max="10" :step="step"
      :disabled="disabled" :thumb-label="false" :ticks="false"
      :color="selected ? '#21865f' : '#97aaa0'" track-color="#dce8e2" hide-details
      @input="$emit('input', Number($event))"
      @change="$emit('change', Number($event))"
      @end="$emit('change', Number($event))"
    />
  </div>
</template>

<script>
export default {
  name: 'FeedbackScale',
  props: {
    value: { type: Number, default: 5 },
    label: { type: String, required: true },
    step: { type: [Number, String], default: 1 },
    disabled: Boolean,
    selected: Boolean
  },
  beforeCreate() {
    // Keep physical left = low and right = high for pointer and keyboard input.
    // This slider context leaves the Persian form and dashboard direction intact.
    this.$vuetify = Object.create(this.$vuetify, { rtl: { value: false } })
  }
}
</script>

<style scoped>
.feedback-scale { direction: ltr; }
.feedback-slider { margin: 0; padding-top: 0; }
</style>
